// import { Pie } from 'vue-chartjs/legacy'
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: ["data", "options", 'width', 'height'],
  watch: {
    data: function () {
      this.$data._chart.destroy();
      this.renderChart(this.data, this.options, this.width, this.height);
    }
  },
  async mounted() {
    this.$nextTick(function () {
      this.renderChart(this.data, this.options, this.width, this.height);
    })
  }
};
